import { ProjectType } from 'nekst-api';
import React from 'react';
import { BaseInputProps, Dropdown, MultiSelectDropdown, Option, useFormContext } from 'ui-builder';

export interface ProjectTypeDropdownProps extends BaseInputProps {
  additionalOptions?: Option<string | null>[];
  isClearable?: boolean;
  includedTypes?: ProjectType[];
}

function getOptions() {
  return [
    {
      value: ProjectType.LISTING,
      label: 'Listing',
    },
    {
      value: ProjectType.PENDING_BUYER,
      label: 'Pending Buyer',
    },
    {
      value: ProjectType.PENDING_SELLER,
      label: 'Pending Seller',
    },
    {
      value: ProjectType.PENDING_DUAL,
      label: 'Pending Dual',
    },
    {
      value: ProjectType.ACTIVE_BUYER,
      label: 'Active Buyer',
    },
    {
      value: ProjectType.OTHER,
      label: 'Other',
    },
  ];

}

export function ProjectTypeDropdown(props: ProjectTypeDropdownProps) {
  const options = [
    ...getOptions(),
    ...props.additionalOptions ? props.additionalOptions : [],
  ];

  if (props.includedTypes && props.includedTypes.length > 0) {
    options.splice(0, options.length, ...options.filter(option => props.includedTypes!.includes(option.value as ProjectType)));
  }

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <Dropdown<string|null>
      {...props}
      options={options}
      isClearable={props.isClearable}
    />
  );
}

export function ProjectTypeMultiSelectDropdown(props: BaseInputProps<ProjectType[]>) {
  let options  = getOptions();

  const formContext = useFormContext();

  const availableProjectTypes = formContext.data?._availableProjectTypes || [];

  if (availableProjectTypes.length > 0) {
    options = options.filter(option => availableProjectTypes.includes(option.value as ProjectType));
  }


  return (
    <MultiSelectDropdown options={options} {...props} />
  )
}
